// extracted by mini-css-extract-plugin
module.exports = {"form":"FactorinRegistrationForm_form__3JOVG","progress":"FactorinRegistrationForm_progress__-g2aB"};